var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Autosuggest',{attrs:{"updateOnSelect":"","value":_vm.innerValue,"label":_vm.config.PROFILE_ADDRESS_COUNTRY,"options":_vm.filteredCountries},on:{"select":_vm.onSelect,"type":_vm.onType,"close":_vm.onClose}})
}
var staticRenderFns = []

export { render, staticRenderFns }